import { SpaClass } from '@features/spa/pages/SpaClasses/SpaClasses.types';
import { useQuery } from '@tanstack/react-query';
import request from '@utils/request';
import { some } from '@utils/some';
import { SPA_AVAILABILITY_TIMEOUT } from './consts';

export const spaClassKeys = {
  spaClassKey: ['spaClass'] as const,
  spaClass: (
    propertyId: number,
    { arrivalDate, perPage }: { arrivalDate: string; perPage: number }
  ) => [...spaClassKeys.spaClassKey, propertyId, { arrivalDate, perPage }] as const,
};

export const useGetSpaClasses = (propertyId: number, arrivalDate: string, perPage = 0) => {
  return useQuery({
    queryFn: () => getSpaClasses(propertyId, { perPage, arrivalDate }),
    queryKey: spaClassKeys.spaClass(propertyId, { arrivalDate, perPage }),
  });
};

export const getSpaClasses = async (propertyId: number, { arrivalDate, perPage }) => {
  const { data } = await request.get(`${propertyId}/spa-classes`, {
    params: {
      arrivalDate,
      perPage,
    },
    timeout: SPA_AVAILABILITY_TIMEOUT,
  });
  return (data.data as Array<SpaClass>).map((spaClass) => ({
    ...spaClass,
    availability: some(spaClass.availability) ? spaClass.availability : [],
  }));
};
